// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ed299be2","455":"41079f07","521":"453a8fc7","977":"45558ecb"}[chunkId] + ".chunk.js";
};